<!--
Date: 2024-04-23
Desc: 设置未开户下页面顶部导航，为公共组件
 -->
<template>
    <div class="comp-step comp">
        <div class="nav-bar">
            <div
                v-for="(nav, index) in navs"
                :key="nav.val"
                :class="{ 'is-active': nav.active }"
                class="comp-step-item"
                :style="{ '--index': `${index * 8}px` }"
            >
                <div class="setp-content">
                    <span class="num">{{ index + 1 }}</span>
                    <span class="step-text">{{ nav.val }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavBar",
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-step {
    .nav-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        .comp-step-item {
            width: 290px;
            height: 40px;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                right: var(--index);
                width: 100%;
                height: 100%;
                background-image: url("../../assets/img/step.png");
                background-size: 100% 100%;
            }
            .setp-content {
                position: absolute;
                display: flex;
                align-items: center;
                height: 56px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 10;
                .num {
                    width: 56px;
                    height: 56px;
                    border: 1px solid #ccc;
                    border-radius: 56px;
                    font-size: 26px;
                    text-align: center;
                    line-height: 56px;
                    color: #ccc;
                    background-color: #fff;
                }
                .step-text {
                    color: #fff;
                    font-size: 18px;
                    font-weight: 500;
                    margin-left: 16px;
                    width: 74px;
                }
            }
        }
        .comp-step-item.is-active {
            &::before {
                background-image: url("../../assets/img/step-active.png");
            }
            .num {
                color: $bg18;
                border: 1px solid $bg18;
                font-weight: bold;
            }
        }
    }
}
</style>
